import ChargeHelper from 'features/Charge/chargeHelper';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';

DialogAddChargeConnectorView.propTypes = {
  chargePointDetail: PropTypes.object.isRequired,
  item: PropTypes.object,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogAddChargeConnectorView({ chargePointDetail, item, onCancel, onDone }) {
  // MARK: ---- PROPERTIES ----
  const editMode = !!item;
  const [loading, setLoading] = useState(false);
  const [serialNumber, setSerialNumber] = useState('');
  const [connectorType, setConnectorType] = useState('');
  useEffect(() => {
    if (item) {
      setSerialNumber(item?.connectorSerial);
      setConnectorType(item?.type);
    } else {
      setSerialNumber(`${chargePointDetail?.serialNumber}-${chargePointDetail?.chargeConnectors?.length + 1 < 10
        ? '0' + (chargePointDetail?.chargeConnectors?.length + 1)
        : (chargePointDetail?.chargeConnectors?.length + 1)}`);
    }
  }, [item]);
  const connectorImageEl = useMemo(() => {
    return Utils.isValid(connectorType) ? (
      <div
        className="p-4 mt-2"
        style={{
          border: `1px solid ${AppColors.gray[300]}`,
          borderRadius: '5px',
        }}
      >
        <div className="d-flex align-items-center justify-content-around">
          <div
            className="d-flex flex-column align-items-center gap-2"
            style={{
              width: '20%',
              aspectRatio: '1/1',
            }}
          >
            <img
              className="w-100 h-100"
              style={{ objectFit: 'contain' }}
              src={
                AppResource.images.chargeConnectorTypes[
                `${Utils.removeSpecialCharacters(connectorType.toLowerCase())}Socket`
                ]
              }
            />
            <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>Socket</span>
          </div>
          <div
            className="d-flex flex-column align-items-center gap-2"
            style={{
              width: '20%',
              aspectRatio: '1/1',
            }}
          >
            <img
              className="w-100 h-100"
              style={{ objectFit: 'contain' }}
              src={
                AppResource.images.chargeConnectorTypes[
                `${Utils.removeSpecialCharacters(connectorType.toLowerCase())}Plug`
                ]
              }
            />
            <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>Plug</span>
          </div>
          <div
            className="d-flex flex-column align-items-center gap-2"
            style={{
              width: '20%',
              aspectRatio: '1/1',
            }}
          >
            <img
              className="w-100 h-100"
              style={{ objectFit: 'contain' }}
              src={
                AppResource.images.chargeConnectorTypes[
                `${Utils.removeSpecialCharacters(connectorType.toLowerCase())}Connector`
                ]
              }
            />
            <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>Type</span>
          </div>
        </div>
      </div>
    ) : (
      <></>
    );
  }, [connectorType]);

  // MARK: ---- METHODS ----
  const handleSubmit = async () => {
    if (!connectorType) {
      ToastHelper.showError('Vui lòng chọn loại vòi sạc');
      return;
    }
    const param = {
      type: connectorType,
      connectorSerial: Utils.isValid(serialNumber) ? serialNumber : null,
    };
    setLoading(true);
    if (!editMode) {
      param.connectorNumber = chargePointDetail?.chargeConnectors?.length + 1;
      const response = await ChargeHelper.API.requestCreateChargeConnector(
        chargePointDetail?.pointId,
        param
      );
      if (_.isBoolean(response) && response) {
        ToastHelper.showSuccess('Thêm vòi sạc thành công');
        if (onDone) {
          onDone();
        }
      } else if (_.isString(response)) {
        ToastHelper.showError(response);
      }
    } else {
      param.connectorNumber = item?.connectorNumber;
      const response = await ChargeHelper.API.requestUpdateChargeConnector(
        chargePointDetail?.pointId,
        item?.connectorId,
        param
      );
      if (_.isBoolean(response) && response) {
        ToastHelper.showSuccess('Cập nhật vòi sạc thành công');
        if (onDone) {
          onDone();
        }
      } else if (_.isString(response)) {
        ToastHelper.showError(response);
      }
    }
    setLoading(false);
  };

  return (
    <div className="mt-4">
      <div className="row m-0 p-0 px-2">
        {/* loai voi sac */}
        <div className="col-12 mb-4 px-2">
          <div>
            {UIHelper.buildFormLabel('Loại vòi sạc', true)}
            <KTBSDropdown
              name="connectorType"
              toggleElement={
                <button
                  className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                  type="button"
                >
                  {connectorType?.length
                    ? ChargeHelper?.Utils?.getChargeConnectorTypeName(connectorType)
                    : 'Chọn loại vòi sạc'}
                </button>
              }
              selectedValue={connectorType}
              dropdownMenuItems={ChargeHelper.Data.chargeConnectorTypeOptions}
              dropdownMenuClassName="overflow-auto w-100"
              dropdownMenuStyle={{ maxHeight: '30vh' }}
              onChange={(value) => {
                setConnectorType(value);
              }}
              isDropdownForm={true}
            />
            {connectorImageEl}
          </div>
        </div>
        {/* so serial */}
        <div className="col-12 mb-4 px-2">
          <div>
            {UIHelper.buildFormLabel('Số serial')}
            <KTFormInput
              type={KTFormInputType.text}
              placeholder={!!item
                ? `${chargePointDetail?.serialNumber}-${item?.connectorNumber < 10 ? '0' + item?.connectorNumber : item?.connectorNumber}`
                : `${chargePointDetail?.serialNumber}-${chargePointDetail?.chargeConnectors?.length + 1 < 10
                  ? '0' + (chargePointDetail?.chargeConnectors?.length + 1)
                  : (chargePointDetail?.chargeConnectors?.length + 1)}`}
              name="serialNumber"
              value={serialNumber}
              onChange={(value) => {
                setSerialNumber(value);
              }}
            // enableCheckValid={true}
            // isValid={_.isEmpty(meta.error)}
            // isTouched={meta.touched}
            // feedbackText={meta.error}
            />
          </div>
        </div>
      </div>

      {/* footer */}
      <div
        className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
        {UIHelper.buildGreenButton(
          !editMode ? 'Thêm' : 'Cập nhật',
          () => {
            handleSubmit();
          },
          null,
          false,
          loading
        )}
      </div>
    </div>
  );
}

export default DialogAddChargeConnectorView;
